import { Pipe, PipeTransform } from '@angular/core';
import { AsYouTypeFormatter } from 'google-libphonenumber';

@Pipe({
    name: 'humanizePhone',
    standalone: false
})
export class HumanizePhonePipe implements PipeTransform {

  private asYouTypeFormatter = AsYouTypeFormatter

  transform(value: string): string {

    let formattedNumber: string | undefined

    if (value && value.length > 0) {
      value = value.replace(/^(00).*?/, '+')
      value = value.replace(/^(\+39)/, '')

      const formatter = new this.asYouTypeFormatter('IT')
      for (let i = 0; i < value.length; ++i) {
        formattedNumber = formatter.inputDigit(value.charAt(i))
      }
    }

    return formattedNumber!
  }

}
